import React from "react";

export default function AppHome() {
  return (
    <div>
      <h2>App Honme...</h2>
    </div>
  );
}